import React, { Children, Suspense } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

// components
import Root from './Root';
import PrivateRoute from './PrivateRoute';

// lazy load all the views
// auth
const Login = React.lazy(() => import('../pages/auth/Login'));
const LoginMy = React.lazy(() => import('../pages/auth/Login_My'));
const SignUp = React.lazy(() => import('../pages/auth/SignUp'));
const ForgetPassword = React.lazy(() => import('../pages/auth/ForgetPassword'));
const Confirm = React.lazy(() => import('../pages/auth/Confirm'));
const Logout = React.lazy(() => import('../pages/auth/Logout'));

// home
const Home = React.lazy(() => import('../pages/Home'));
const homeCustom = React.lazy(() => import('../pages/home-custom'));


//produk hukum
const Peraturan = React.lazy(() => import('../pages/produk-hukum/peraturan'));
const PeraturanEksternal = React.lazy(() => import('../pages/produk-hukum/peraturan-eksternal'));
const PeraturanSm = React.lazy(() => import('../pages/produk-hukum/peraturan-sm'));
const detailPeraturan = React.lazy(() => import('../pages/produk-hukum/peraturan/detail'));
const detailPeraturanEksternal = React.lazy(() => import('../pages/produk-hukum/peraturan-eksternal/detail'));
const detailPeraturanSm = React.lazy(() => import('../pages/produk-hukum/peraturan-sm/detail'));
const detailPutusan = React.lazy(() => import('../pages/produk-hukum/putusan-pengadilan-new/detail'));
const detailKarya = React.lazy(() => import('../pages/produk-hukum/monografi/detail'));
const detailChecklist = React.lazy(() => import('../pages/produk-hukum/checklist/detail'));

const detailPendapat = React.lazy(() => import('../pages/produk-hukum/pendapat/detail'));
const documentDetail = React.lazy(() => import('../pages/produk-hukum/document/detail'));




const UndangUndang = React.lazy(() => import('../pages/produk-hukum/undang-undang'));
const undangUndangDetail = React.lazy(() => import('../pages/produk-hukum/undang-undang/detail'));

const anggaranDasar = React.lazy(() => import('../pages/produk-hukum/anggaran-dasar'));
const anggaranDasarDetail = React.lazy(() => import('../pages/produk-hukum/anggaran-dasar/detail'));

const Putusan = React.lazy(() => import('../pages/produk-hukum/putusan-pengadilan-new'));
const monografi = React.lazy(() => import('../pages/produk-hukum/monografi'));
const artikel = React.lazy(() => import('../pages/produk-hukum/artikel'));
const pengaturanBumn = React.lazy(() => import('../pages/produk-hukum/peraturan-bumn'));
const detailBumn = React.lazy(() => import('../pages/produk-hukum/peraturan-bumn/detail'));
const matriks = React.lazy(() => import('../pages/produk-hukum/matriks'));

const putusanpengadilan = React.lazy(() => import('../pages/produk-hukum/putusan-pengadilan'));
const pendapatHukum = React.lazy(() => import('../pages/produk-hukum/pendapat'));
const checklist = React.lazy(() => import('../pages/produk-hukum/checklist'));
const perizinan = React.lazy(() => import('../pages/produk-hukum/perizinan'));
const document = React.lazy(() => import('../pages/produk-hukum/document'));
const bookmark = React.lazy(() => import('../pages/bookmark'));


//publikasi
const berita = React.lazy(() => import('../pages/publikasi/berita'));
const admin = React.lazy(() => import('../pages/admin/account/Dashboard'));
const settings = React.lazy(() => import('../pages/admin/account/Settings'));
const helloLawyer = React.lazy(() => import('../pages/admin/account/hello-lawyer'));
const profile = React.lazy(() => import('../pages/admin/account/Profile'));
const kamusHukumAdmin = React.lazy(() => import('../pages/admin/account/kamus-hukum'));
const beritaDetail = React.lazy(() => import('../pages/publikasi/berita/detail'));
const infografis = React.lazy(() => import('../pages/publikasi/infografis'));
const infografisDetail = React.lazy(() => import('../pages/publikasi/infografis/detail'));
const galeri = React.lazy(() => import('../pages/publikasi/galeri'));
const video = React.lazy(() => import('../pages/publikasi/video'));
const kamusHukum = React.lazy(() => import('../pages/publikasi/kamus-hukum'));
const statistik = React.lazy(() => import('../pages/publikasi/statistik'));

//profil
const tentang = React.lazy(() => import('../pages/profil/tentang'));
const struktur = React.lazy(() => import('../pages/profil/struktur'));
const faq = React.lazy(() => import('../pages/profil/faq'));


//my approval
const detailRequest = React.lazy(() => import('../pages/produk-hukum/request-view'));



// admin

const pendapatHukumAdmin = React.lazy(() => import('../pages/admin/account/pendapat-hukum'));
const dokumenHukumAdmin = React.lazy(() => import('../pages/admin/account/dokumen-hukum'));
const beritaPanel = React.lazy(() => import('../pages/admin/account/berita'));
const videoPanel = React.lazy(() => import('../pages/admin/account/video'));
const infografisPanel = React.lazy(() => import('../pages/admin/account/infografis'));
const checklistHukumAdmin = React.lazy(() => import('../pages/admin/account/checklist'));
const putusanpengadilanAdmin = React.lazy(() => import('../pages/admin/account/putusan-pengadilan'));
const peraturanAdmin = React.lazy(() => import('../pages/admin/account/peraturan'));
const anggaranAdmin = React.lazy(() => import('../pages/admin/account/anggaran-dasar'));
const requestAdmin = React.lazy(() => import('../pages/admin/account/request-peraturan'));
const aksesUser = React.lazy(() => import('../pages/admin/account/akses-akun'));




const loading = () => <div className=""></div>;

type LoadComponentProps = {
    component: React.LazyExoticComponent<() => JSX.Element>;
};

const LoadComponent = ({ component: Component }: LoadComponentProps) => (
    <Suspense fallback={loading()}>
        <Component />
    </Suspense>
);

const AllRoutes = () => {
    return useRoutes([
        {
            // root route
            path: '/',
            element: <Navigate to="/auth/login" replace />, // ⬅️ redirect otomatis
        },
        {
            // root route
            path: '/login',
            element: <Navigate to="/auth/login" replace />, // ⬅️ redirect otomatis
        },
        {
            // public routes
            path: '/',
            children: [
                {
                    path: 'auth',
                    children: [
                        { path: 'login', element: <LoadComponent component={Login} /> },
                        { path: 'login_my', element: <LoadComponent component={LoginMy} /> },
                        { path: 'login_my/:id', element: <LoadComponent component={LoginMy} /> },
                        { path: 'signup', element: <LoadComponent component={SignUp} /> },
                        { path: 'forget-password', element: <LoadComponent component={ForgetPassword} /> },
                        { path: 'confirm', element: <LoadComponent component={Confirm} /> },
                        { path: 'logout', element: <LoadComponent component={Logout} /> },
                        
                    ],
                },
                {
                    path: 'request-view',
                    element: <LoadComponent component={detailRequest} />,
                },



            ],
        },
        {
            // privat admin routes
            path: '/admin',
            element: <PrivateRoute roles={'AO,AC'} />,
            children: [
                { path: 'admin', element: <LoadComponent component={admin} /> },
                { path: 'dokumen-hukum', element: <LoadComponent component={dokumenHukumAdmin} /> },
                { path: 'settings', element: <LoadComponent component={settings} /> },
                { path: 'hello-lawyer', element: <LoadComponent component={helloLawyer} /> },
                { path: 'kamus-hukum', element: <LoadComponent component={kamusHukumAdmin} /> },
                { path: 'request', element: <LoadComponent component={requestAdmin} /> },
                { path: 'profil-visi-misi', element: <LoadComponent component={profile} /> },
                { path: 'pendapat-hukum', element: <LoadComponent component={pendapatHukumAdmin} /> },
                { path: 'berita-era', element: <LoadComponent component={beritaPanel} /> },
                { path: 'video-era', element: <LoadComponent component={videoPanel} /> },
                { path: 'infografis-era', element: <LoadComponent component={infografisPanel} /> },
                { path: 'checklist', element: <LoadComponent component={checklistHukumAdmin} /> },
                { path: 'putusan-pengadilan', element: <LoadComponent component={putusanpengadilanAdmin} /> },
                { path: 'peraturan/:id', element: <LoadComponent component={peraturanAdmin} /> },
                { path: 'anggaran-dasar/:id', element: <LoadComponent component={anggaranAdmin} /> },
                {
                    path: "akses",
                    children: [
                        {
                            path: 'super-akun', element: <LoadComponent component={aksesUser} />
                        },

                    ]
                },

            ],
        },
        {
            // protected routes
            path: '/',
            element: <PrivateRoute roles={'OO,UO,AO,AC'} />,
            children: [


                {
                    path: 'home',
                    element: <LoadComponent component={homeCustom} />,
                },
                {
                    path: 'home-custom',
                    element: <LoadComponent component={Home} />,
                },
                {
                    path: 'bookmark',
                    element: <LoadComponent component={bookmark} />,
                },
               

                {
                    path: 'produk-hukum',
                    children: [
                        {
                            path: 'peraturan', element: <LoadComponent component={Peraturan} />
                        },
                        {
                            path: 'peraturan-eksternal', element: <LoadComponent component={PeraturanEksternal} />
                        },
                        {
                            path: 'peraturan-sebelum-merger', element: <LoadComponent component={PeraturanSm} />
                        },
                        {
                            path: 'peraturan/:id', element: <LoadComponent component={Peraturan} />
                        },
                        {
                            path: 'peraturan-eksternal/:id', element: <LoadComponent component={PeraturanEksternal} />
                        },
                        {
                            path: 'peraturan/detail', element: <LoadComponent component={detailPeraturan} />,

                        },
                        {
                            path: 'peraturan-eksternal/detail', element: <LoadComponent component={detailPeraturanEksternal} />,

                        },
                        {
                            path: 'peraturan/detail/:id', element: <LoadComponent component={detailPeraturan} />,

                        },
                        {
                            path: 'peraturan-eksternal/detail/:id', element: <LoadComponent component={detailPeraturanEksternal} />,

                        },
                        {
                            path: 'peraturan-sebelum-merger/detail', element: <LoadComponent component={detailPeraturanSm} />,

                        },
                        {
                            path: 'peraturan-sebelum-merger/detail/:id', element: <LoadComponent component={detailPeraturanSm} />,

                        },
                        {
                            path: 'karyailmiah/detail', element: <LoadComponent component={detailKarya} />,

                        },
                        {
                            path: 'karyailmiah/detail/:id', element: <LoadComponent component={detailKarya} />,

                        },
                        {
                            path: 'putusan', element: <LoadComponent component={Putusan} />,

                        },
                        {
                            path: 'undang-undang', element: <LoadComponent component={UndangUndang} />,

                        },
                        {
                            path: 'undang-undang/detail/:id', element: <LoadComponent component={undangUndangDetail} />,

                        },
                        {
                            path: 'undang-undang/detail', element: <LoadComponent component={undangUndangDetail} />,

                        },
                        {
                            path: 'anggaran-dasar', element: <LoadComponent component={anggaranDasar} />,

                        },
                        {
                            path: 'anngaran-dasar/detail/:id', element: <LoadComponent component={anggaranDasarDetail} />,

                        },
                        {
                            path: 'anggaran-dasar/detail', element: <LoadComponent component={anggaranDasarDetail} />,

                        },
                        {
                            path: 'putusan/detail', element: <LoadComponent component={detailPutusan} />,

                        },
                        {
                            path: 'putusan/detail/:id', element: <LoadComponent component={detailPutusan} />,

                        },
                        {
                            path: 'karyailmiah', element: <LoadComponent component={monografi} />,

                        },
                        {
                            path: 'artikel', element: <LoadComponent component={artikel} />,

                        },
                        {
                            path: 'peraturan-bumn', element: <LoadComponent component={pengaturanBumn} />,

                        },
                        {
                            path: 'peraturan-bumn/detail/:id', element: <LoadComponent component={detailBumn} />,

                        },
                        {
                            path: 'peraturan-bumn/detail/', element: <LoadComponent component={detailBumn} />,

                        },
                        {
                            path: 'matriks', element: <LoadComponent component={matriks} />,
                        },
                        {
                            path: 'putusan-pengadilan', element: <LoadComponent component={Putusan} />
                        },
                        {
                            path: 'putusan-pengadilan/detail/', element: <LoadComponent component={detailPutusan} />
                        },
                        {
                            path: 'putusan-pengadilan/detail/:id', element: <LoadComponent component={detailPutusan} />
                        },
                        {
                            path: 'perizinan', element: <LoadComponent component={perizinan} />
                        },
                        {
                            path: 'checklist', element: <LoadComponent component={checklist} />
                        },
                        {
                            path: 'checklist/detail', element: <LoadComponent component={detailChecklist} />,

                        },
                        {
                            path: 'checklist/detail/:id', element: <LoadComponent component={detailChecklist} />,

                        },
                        {
                            path: 'kamus-hukum', element: <LoadComponent component={kamusHukum} />
                        },
                        {
                            path: 'pendapat-hukum', element: <LoadComponent component={pendapatHukum} />
                        },
                        {
                            path: 'pendapat-hukum/detail', element: <LoadComponent component={detailPendapat} />,

                        },
                        {
                            path: 'pendapat-hukum/detail/:id', element: <LoadComponent component={detailPendapat} />,

                        },
                        {
                            path: 'dokumen-hukum', element: <LoadComponent component={document} />
                        },
                        {
                            path: 'dokumen-hukum/detail', element: <LoadComponent component={documentDetail} />
                        },
                        {
                            path: 'dokumen-hukum/detail/:id', element: <LoadComponent component={documentDetail} />
                        },
                    ],
                },
                {
                    path: "publikasi",
                    children: [
                        {
                            path: 'berita', element: <LoadComponent component={berita} />
                        },
                        {
                            path: 'berita/detail/:id', element: <LoadComponent component={beritaDetail} />
                        },
                        {
                            path: 'berita/detail', element: <LoadComponent component={beritaDetail} />
                        },
                        {
                            path: 'infografis', element: <LoadComponent component={infografis} />
                        },
                        {
                            path: 'infografis/detail/:id', element: <LoadComponent component={infografisDetail} />
                        },
                        {
                            path: 'infografis/detail/', element: <LoadComponent component={infografisDetail} />
                        },
                        {
                            path: 'galeri', element: <LoadComponent component={galeri} />
                        },
                        {
                            path: 'video', element: <LoadComponent component={video} />
                        },

                        {
                            path: 'statistik', element: <LoadComponent component={statistik} />
                        },
                    ]
                },
                {
                    path: "profil",
                    children: [
                        {
                            path: 'tentang-sihukum', element: <LoadComponent component={tentang} />
                        },
                        {
                            path: 'struktur-sihukum', element: <LoadComponent component={struktur} />
                        },
                        {
                            path: 'faq', element: <LoadComponent component={faq} />
                        }
                    ]
                },

            ],
        },
    ]);
};

export default AllRoutes;
